/* eslint-disable */
import React from "react";

const SpinnerButton = ({children, loading, disabled, className, onClick, type}) => {
    const isDisabled = disabled || loading;
    const btnClass = [
        className || '',
        loading ? 'webinar-btn--loading' : '',
    ].filter(Boolean).join(' ');

    return (
        <button
            className={btnClass}
            onClick={!isDisabled ? onClick : undefined}
            disabled={isDisabled}
            type={type || 'button'}
        >
            <span className="webinar-btn__content">
                {children}
                {loading && <span className="webinar-btn-spinner"/>}
            </span>
        </button>
    );
};

export default SpinnerButton;



// WEBPACK FOOTER //
// ./src/components/Webinars/SpinnerButton.js